import { useState } from 'react'
import styles from './styles.module.scss'
import { LoginInput } from '../../components/LoginInput/LoginInput'
import { LoginButton } from '../../components/LoginButton/LoginButton'
import { authenticate } from '../../services/login'
import { useNavigate } from 'react-router-dom'
import routes from '../../routes/routes'

export function LoginPage() {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [wrongCredentials, setWrongCredentials] = useState(false)

  const handleLogin = async () => {
    if (await authenticate(username, password)) {
      navigate(routes.ContactList.path, { replace: true })
    }

    return setWrongCredentials(true)
  }

  return (
    <div className={styles.login}>

      <div className={styles.information}>
        <h3>Login</h3>
        <p>{`Por favor, faça seu login para \nacessar a Judite`}</p>
      </div>

      <div className={styles.fields}>
        <LoginInput
          required
          type='text'
          label='Nome'
          placeholder='Digite seu nome.sobrenome'
          onChange={event => setUsername(event.currentTarget.value)}
        />
        <LoginInput
          required
          type='password'
          label='Senha'
          placeholder='Digite sua senha'
          onChange={event => setPassword(event.currentTarget.value)}
        />
      </div>

      <div className={styles.signIn}>
        <LoginButton
          className={styles.signInButton}
          buttonText='Entrar'
          onClick={handleLogin} />

        {wrongCredentials ? (
          <p className={styles.wrongCredentials}>Usuário ou senha incorretos</p>
        ) : (
          ''
        )}
      </div>

      <div className={styles.forgotPassword}>
        <a href='#'>Esqueceu a senha?</a>
      </div>
    </div>
  )
}
